// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Cofre_IndexInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Input contract for GET /cofre (index).
 */
import { registerContract } from './validate'

export interface Cofre_IndexInput {
franquia_id?: number
page?: number
per_page?: number
}

registerContract('Cofre_IndexInput', {
  franquia_id: { type: 'number',  required: false },
  page:        { type: 'number',  required: false },
  per_page:    { type: 'number',  required: false },
})
